import React from 'react';

import AlertSuccess from '@rover/icons/svg/alert-success.svg';
import Calendar from '@rover/icons/svg/calendar.svg';
import { Flex, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

export type Props = {
  calendarRecency?: {
    description: string;
    icon: string;
  };
};

export const getIcons = (theme: RoverTheme): Record<string, React.ReactElement> => ({
  greenCheck: (
    <AlertSuccess
      width="16px"
      height="16px"
      fill={theme.textColor.success}
      color={theme.textColor.success}
    />
  ),
  calendarIcon: (
    <Calendar
      width="16px"
      height="16px"
      fill={theme.textColor.caution}
      color={theme.textColor.caution}
    />
  ),
});

const CalendarRecency: React.FC<Props> = ({ calendarRecency }) => {
  const theme = useTheme();
  const icons = getIcons(theme);

  if (!calendarRecency) {
    return null;
  }

  const { icon, description } = calendarRecency;

  return (
    <Flex data-testid="calendar-recency" py="1x" pr="4x" gap="1x">
      {icons[icon]}
      <Text size="100">{description}</Text>
    </Flex>
  );
};

export default CalendarRecency;
